var PRECISION = 10;

export { PRECISION };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-drawing/dist/es/geometry/constants.js
// module id = 145
// module chunks = 0